var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2049 12.5901C21.6615 12.1957 22.3383 12.1957 22.795 12.5901L27.8385 16.9459V26.5957C27.8385 27.2675 27.294 27.8121 26.6222 27.8121H17.3777C16.7059 27.8121 16.1613 27.2675 16.1613 26.5957V22.9466C16.1613 21.603 15.0721 20.5138 13.7286 20.5138V26.5957C13.7286 28.6111 15.3623 30.2448 17.3777 30.2448H26.6222C28.6375 30.2448 30.2713 28.6111 30.2713 26.5957V19.0469L30.9884 19.6663C31.4968 20.1054 32.2649 20.0492 32.704 19.5407C33.1431 19.0323 33.0869 18.2642 32.5785 17.8251L24.3851 10.749C23.0151 9.56578 20.9848 9.56578 19.6148 10.749L11.4213 17.8251C10.9129 18.2642 10.8567 19.0323 11.2958 19.5407C11.7349 20.0492 12.503 20.1054 13.0114 19.6663L21.2049 12.5901Z",
    fill: "#8888B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingStep1);
export default __webpack_public_path__ + "static/media/onboarding-step-1.a3eb6b7c.svg";
export { ForwardRef as ReactComponent };